import { Typography } from "@mui/material"
import { PostBotPageLayout } from "../components/common/postBotPageLayout"
import {
  useMediaUploads,
  type MediaWriteAccess,
} from "../hooks/useMediaUploads"
import { PostBotNavigation } from "../components/common/postBotNavigation"
import { MediaLibrary } from "../components/media/mediaLibrary"
import { MediaUploadQueue } from "../components/media/mediaUploadQueue"

/** Route registration and permission policy are owned by the caller. */
export default function MediaPage(props: MediaWriteAccess) {
  const uploads = useMediaUploads(props)
  return (
    <PostBotPageLayout>
      <PostBotNavigation />
      <Typography variant="h5">Медиабиблиотека</Typography>
      <MediaUploadQueue uploads={uploads} {...props} />
      <MediaLibrary {...props} />
    </PostBotPageLayout>
  )
}
